import axios from "./newAioxs";

// 初始化
export const onInitAPI = (params) => {
  return axios(
    { url: "/v2/lantern/online/init", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 领取奖励
export const onGetRewardAPI = (params) => {
  return axios(
    { url: "/v2/lantern/online/reward", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 助力
export const onHelpAPI = (params) => {
  return axios(
    { url: "/v2/lantern/online/help", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 翻牌
export const onTurnAPI = (params) => {
  return axios(
    { url: "/v2/lantern/online/turn/card", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 完成任务
export const doTaskAPI = (params) => {
  return axios(
    { url: "/v2/lantern/online/make/task", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 领取任务奖励
export const getRewardAPI = (params) => {
  return axios(
    { url: "/v2/lantern/online/reward/task", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 领取任务奖励
export const noSecLogin = (params) => {
  return axios(
    { url: "/v2/game/single/sign", method: "POST", params },
    { interceptResultCode: false }
  );
};



// WEBPACK FOOTER //
// ./src/pages/tideng/new-version/api.js